'use strict';

/* eslint camelcase: 0 */
/* eslint max-lines-per-function: 0 */

var Page = require('stb-component-page'),
    dom  = require('spa-dom'),
    keys = require('stb-keys'),
    app  = require('mag-app'),

    LayoutList   = require('mag-component-layout-list'),
    ModalMessage = require('mag-component-modal'),
    RadioList    = require('mag-component-radio-list'),
    Layout       = require('mag-component-layout'),

    CacheList    = require('../components/item.list'),

    utils = {
        prepareScreenshots: require('../utils/prepare.screenshots'),
        prepareSeasons: require('../utils/prepare.seasons'),
        sortQuality: require('../utils/sort.quality'),
        selectFile: require('../utils/select.file'),
        prepareSeries: require('../utils/prepare.series'),
        prepareFiles: require('../utils/prepare.files'),
        toggleFavorite: require('../utils/toggle.favorite')
    },

    page          = new Page({$node: document.getElementById('pageInfo')}),
    configFiles   = {},
    configRequest = {},
    infoData      = null,
    tag           = dom.tag,

    infoBlock, buttonList, buttonMore,

    buttons, buttonsData, buttonsDataWatch,
    buttonsSerialsWatch,

    prevPage, fillFileList,
    screenList, seasonsList, seasonsButton,
    seriesList, seasonData, scrollPosition,
    selectFileModal, fileList, season,
    episode, episodes;

/**
 * Save new video watched states.
 *
 * @param {Object} video - intent, context and movie data
 * @param {boolean} end - end of file
 */
function saveVideo ( video, end ) {
    var intent = video.intent,
        context = video.context,
        item, position, duration,
        progress, config;

    // check save function
    function add ( error, data ) {
        var statusText, disabled;

        if ( !error && data && data.status ) {
            item.file['watched_status'] = config['watched_status'];

            if ( item.season ) {
                item.movie['last_watched_season_id'] = item.season.id;
                item.season['watched_status'] = data['season_watched_status'];
            }

            if ( item.episode ) {
                switch ( config['watched_status'] ) {
                    case 'watched':
                        statusText = gettext('Watched');
                        disabled = true;
                        break;
                    case 'not_watched':
                        statusText = '';
                        disabled = false;
                        break;
                    case 'not_ended':
                        statusText = gettext('Not finished');
                        disabled = false;
                        break;
                }
                item.episode['watched_status'] = config['watched_status'];
                item.movie['last_watched_episode_id'] = item.episode.id;

                if ( item.episode.status ) {
                    item.episode.status.$focus.innerText = statusText;
                    item.episode.status.$blur.innerText = statusText;
                    if ( disabled ) {
                        item.episode.status.$focus.classList.add('disabled');
                        item.episode.status.$blur.classList.add('disabled');
                    } else {
                        item.episode.status.$focus.classList.remove('disabled');
                        item.episode.status.$blur.classList.remove('disabled');
                    }
                }
            }

            app.pages.main.emit('change:watched', infoData);

            if ( infoData['watched_status'] === 'not_ended' ) {
                if ( infoData['is_tv_series'] ) {
                    buttonList.setData({data: buttonsSerialsWatch, focusIndex: 0});
                } else {
                    buttonList.setData({data: buttonsDataWatch, focusIndex: 0});
                }
            } else {
                buttonList.setData({data: buttonsData, focusIndex: 0});
            }
        }

    }

    if ( intent.data && context ) {
        position = context.metadata.position;
        duration = context.metadata.duration;
        // position = intent.playback.position;
        // duration = intent.playback.duration;
        item = intent.data;
        if ( position > 10 ) {
            if ( position && duration ) {
                progress = position / duration * 100;
                if ( progress > 95 || end ) {
                    config = {
                        watched_status: 'watched',
                        watched_time: position - 10
                    };
                } else if ( progress > 5 ) {
                    config = {
                        watched_status: 'not_ended',
                        watched_time: position - 10
                    };
                }
                config.progress = progress;
                item.file['watched_status'] = config['watched_status'];
                item.file['watched_time'] = config['watched_time'];
                item.movie['watched_time'] = config['watched_time'];
                item.movie['last_watched_file_id'] = item.file.id;
                item.movie.changeWatchedFile(item.file.id, config, add);
            }
        }
    }
}

/**
 * Prepare object to play.
 *
 * @param {Object} data - data to play
 * @param {number} position - start position
 * @param {Object} context - player context
 */
function prepareToPlay ( data, position, context ) {
    var item = data,
        name = infoData.name,
        // episode = null,
        intent = null,
        next = null,
        prev = null;

    // if ( infoData.is_tv_series ) {
    //     episode = seriesList.$focusItem.data;
    // }

    function selectNextFile ( file, languages ) {
        var files = utils.sortQuality(file.files, infoData);

        files = utils.prepareFiles(files.video);
        file = utils.selectFile(files, languages, intent.data.file);

        if ( file ) {
            prepareToPlay(file.value, 0, context);
        } else {
            fillFileList(seriesList.$focusItem.data.value, function () {
                seriesList.blur();
                selectFileModal.prevFocus = seriesList;
                setTimeout(function () {
                    selectFileModal.show();
                }, app.config.delay.modalShow);
            });

            context = null;
            intent.close();
        }
    }

    /**
     * Play object.
     *
     * @param {boolean} error - error
     * @param {string} uri - uri to play
     */
    function play ( error, uri ) {
        var index = 0;

        if ( error ) {

            return;
        }

        if ( infoData.is_tv_series ) {
            name += ' ' + season.custName + ' ' + episode.custName;
            index = episodes.indexOf(episode);

            if ( index + 1 < episodes.length ) {
                next = function () {
                    var lang = context.metadata.audioLang;

                    saveVideo({intent: intent, context: context});
                    index = episodes.indexOf(episode);

                    if ( index === -1 ) {
                        context = null;
                        intent.close();

                        return;
                    }

                    if ( seriesList.visible ) {
                        seriesList.move(keys.down);
                        episode = seriesList.$focusItem.value;
                    } else {
                        episode = episodes[++index];
                    }
                    selectNextFile(episode, lang);
                };
            }

            if ( index > 0 ) {
                prev = function () {
                    var lang = context.metadata.audioLang;

                    saveVideo({intent: intent, context: context});
                    index = episodes.indexOf(episode);

                    if ( index === -1 ) {
                        context = null;
                        intent.close();

                        return;
                    }

                    if ( seriesList.visible ) {
                        seriesList.move(keys.up);
                        episode = seriesList.$focusItem.value;
                    } else {
                        episode = episodes[--index];
                    }
                    selectNextFile(episode, lang);
                };
            }
        }

        function startPlay () {
            intent = core.intent({
                action: 'play',
                mime: 'content/video',
                data: {
                    title: name,
                    uri: uri,
                    movie: infoData,
                    file: item,
                    season: season,
                    episode: episode,
                    position: position,
                    subtitles: configFiles.subtitles,
                    mediaId: item.id
                },
                events: {
                    end: function () {
                        if ( next ) {
                            next();

                            return;
                        }
                        saveVideo({intent: intent, context: context}, true);
                        context = null;
                        intent.close();
                    },
                    error: function () {
                        saveVideo({intent: intent, context: context});
                        context = null;
                        intent.close();
                    },
                    stop: function () {
                        saveVideo({intent: intent, context: context});
                        context = null;
                        intent.close();
                    },
                    hide: function () {
                        saveVideo({intent: intent, context: context});
                        context = null;
                        intent.close();
                    },
                    next: next,
                    prev: prev,
                    close: function () {
                        if ( context ) {
                            saveVideo({intent: intent, context: context});
                            context = null;
                        }
                    }
                },
                context: context
            }, function ( error, cont ) {
                debug.fail('Play error', error);
                context = cont;
            });
        }

        startPlay();
    }

    if ( item.url ) {
        play(false, item.url);
    } else {
        infoData.getUrl(item.id, play);
    }
}

/**
 * Get, prepare and set files data.
 *
 * @param {Object} config - to request
 * @param {Function} callback - result handler
 */
fillFileList = function ( config, callback ) {
    var list = [];

    if ( infoData.is_tv_series ) {
        configRequest.episodeId = config.id;
        episode = config;
        if ( config.files && config.files.length ) {
            configFiles = utils.sortQuality(config.files, infoData);
            list = utils.prepareFiles(configFiles.video);
            if ( list.length > 0 ) {
                if ( list.length > 1 ) {
                    fileList.setData({focusIndex: 0, data: list});
                } else {
                    prepareToPlay(list[0].value);

                    return;
                }
            }

            callback();
        } else {
            infoData.getEpisode(configRequest, function ( error, data ) {
                if ( error ) {
                    configFiles = {video: [], subtitles: []};
                } else {
                    configFiles = utils.sortQuality(data.files, infoData);
                    list = utils.prepareFiles(configFiles.video);
                }

                if ( list.length > 0 ) {
                    if ( list.length > 1 ) {
                        fileList.setData({focusIndex: 0, data: list});
                    } else {
                        prepareToPlay(list[0].value);

                        return;
                    }
                }

                callback();
            });
        }
    } else {
        episode = null;
        season = null;
        configFiles = utils.sortQuality(infoData.files, infoData);
        list = utils.prepareFiles(configFiles.video);
        if ( list.length > 0 ) {
            if ( list.length > 1 ) {
                fileList.setData({focusIndex: 0, data: list});
            } else {
                prepareToPlay(list[0].value);

                return;
            }
        }

        callback();
    }
};

/**
 * Prepare and set season data.
 *
 * @param {Object} data - history
 */
function fillSeason ( data ) {
    data = data || {};
    seriesList.title.innerText = gettext('Seasons');
    if ( seasonData.length ) {
        seriesList.setData({focusIndex: data.position || 0, data: utils.prepareSeasons(seasonData, true)});
    } else {
        seriesList.setData({focusIndex: 0, data: []});
    }
}

/**
 * Get, prepare and set series data.
 *
 * @param {Object} config - to request
 * @param {Function} callback - result handler
 */
function fillSeries ( config, callback ) {
    season = config;
    configRequest.seasonId = config.id;
    seriesList.title.innerText = config.custName;

    infoData.getSeries(config.id, function ( error, data ) {
        var list = error ? [] : utils.prepareSeries(data);

        episodes = data;
        seriesList.setData({focusIndex: 0, data: list});
        callback();
    });
}

/**
 * Change favorite state.
 */
function toggleFavorite () {
    if ( infoData.favorite ) {
        buttonList.$node.classList.remove('inFavorite');
    } else {
        buttonList.$node.classList.add('inFavorite');
    }
    utils.toggleFavorite(infoData);
}


function prepareFiles () {
    if ( infoData.is_tv_series ) {
        if ( seasonData.length ) {
            season = seasonData[0];
            if ( !season.custName ) {
                season.custName = season.name ? season.name +
                    ( season.original_name ? ' ( ' + season.original_name + ' )' : '' ) : gettext('Season') + ' ' + season.number;
            }
            infoData.getSeries(season.id, function ( error, data ) {
                if ( !error && data.length ) {
                    utils.prepareSeries(data);
                    episodes = data;
                    episode = data[0];

                    fillFileList(episode, function () {
                        buttonList.blur();
                        selectFileModal.prevFocus = buttonList;
                        setTimeout(function () {
                            selectFileModal.show();
                        }, app.config.delay.modalShow);

                    });

                }
            });
        }
    } else {
        fillFileList(null, function () {
            buttonList.blur();
            selectFileModal.prevFocus = buttonList;
            setTimeout(function () {
                selectFileModal.show();
            }, app.config.delay.modalShow);
        });
    }
}


function startLastWatched () {
    var indexes = {},
        file, index;

    function checkFile ( data ) {
        var list;

        configFiles = utils.sortQuality(data, infoData);
        list = configFiles.video;
        if ( !list.length ) {
            return;
        }

        if ( infoData.last_watched_file_id ) {
            for ( index = 0; index < list.length; index++ ) {
                if ( list[index].id === infoData.last_watched_file_id ) {
                    file = list[index];
                    break;
                }
            }
        } else {
            file = list[0];
        }
        prepareToPlay(file, infoData.watched_time);
    }

    if ( infoData.is_tv_series ) {
        if ( infoData.last_watched_season_id ) {
            for ( index = 0; index < seasonData.length; index++ ) {
                if ( seasonData[index].id === infoData.last_watched_season_id ) {
                    season = seasonData[index];
                    if ( !season.custName ) {
                        season.custName = season.name ? season.name +
                            (season.original_name ? ' ( ' + season.original_name + ' )' : '') : gettext('Season') + ' ' + season.number;
                    }
                    indexes.season = index;
                    break;
                }
            }

            infoData.getSeries(season.id, function ( error, data ) {
                if ( !error && data.length ) {
                    utils.prepareSeries(data);
                    episodes = data;
                    if ( infoData.last_watched_episode_id ) {
                        for ( index = 0; index < data.length; index++ ) {
                            if ( data[index].id === infoData.last_watched_episode_id ) {
                                episode = data[index];
                                episode.custName = episode.name ? episode.name +
                                    (episode['original_name']
                                        ? ' ( ' + episode['original_name'] + ' )'
                                        : '') : gettext('Series') + ' ' + episode.number;
                                break;
                            }
                        }
                    }

                    if ( episode.files && episode.files.length ) {
                        checkFile(episode.files);
                    } else {
                        infoData.getEpisode({seasonId: season.id, episodeId: episode.id}, function ( error, episodeData ) {
                            if ( !error ) {
                                checkFile(episodeData.files);
                            }
                        });
                    }

                }
            });
        }
    } else {
        checkFile(infoData.files);
    }
}

buttons = {
    continueWatching: {
        icon: 'theme-icon theme-icon-play',
        value: [gettext('Continue watching')],
        click: startLastWatched
    },
    watchAgain: {
        icon: 'theme-icon theme-icon-reset',
        value: [gettext('Watch again')],
        click: prepareFiles
    },
    favorite: {
        icon: 'theme-icon theme-icon-favorite-active',
        value: [gettext('Add to favorites'), gettext('Remove from favorites')],
        click: toggleFavorite
    },
    play: {
        icon: 'theme-icon theme-icon-play',
        value: [gettext('Play')],
        click: prepareFiles
    }
};

buttonsData = [buttons.play, buttons.favorite];
buttonsDataWatch = [buttons.continueWatching, buttons.watchAgain, buttons.favorite];
buttonsSerialsWatch = [buttons.continueWatching, buttons.favorite];

infoBlock = require('../utils/init.info')();

buttonList = new LayoutList({
    cycle: false,
    className: 'buttonList',
    render: function ( $item, config ) {
        var layout, focus, icon,
            button;

        while ( $item.firstChild ) {
            $item.removeChild($item.firstChild);
        }
        button = tag('div', {className: 'button'});
        icon = tag('div', {className: config.icon});
        button.appendChild(icon);

        focus = tag('div', {className: 'buttonFocus'});
        icon = tag('div', {className: config.icon});
        focus.appendChild(icon);

        while ( $item.firstChild ) {
            $item.removeChild($item.firstChild);
        }

        if ( config.value.length === 1 ) {
            layout = new Layout({
                focusable: false,
                data: [
                    button,
                    {className: 'buttonTitle', value: config.value[0]},
                    focus
                ]
            });
        } else {
            layout = new Layout({
                focusable: false,
                data: [
                    button,
                    {className: 'buttonFirstTitle', value: config.value[0]},
                    {className: 'buttonSecondTitle', value: config.value[1]},
                    focus
                ]
            });
        }

        $item.appendChild(layout.$node);
        $item.layout = layout;
        layout.parent = this;
        layout.$parentItem = $item;

        // focus layoutList if click on layout
        layout.addListener('click', function () {
            // add inner property to set that event comes from inner component
            layout.parent.emit('click:item', {$item: $item, inner: true});
        });

        if ( config.click ) {
            this.handlers[$item.index] = config.click;
        }
        // item is rendered
        $item.ready = true;

        $item.value = config.value || {};
    },
    data: [],
    size: app.metrics.buttonList.size,
    focusIndex: 0,
    type: LayoutList.prototype.TYPE_HORIZONTAL,
    events: {
        keydown: function ( event ) {
            switch ( event.code ) {
                case keys.up:
                    event.stop = true;
                    if ( buttonMore.visible ) {
                        buttonMore.focus();
                    }
                    break;
                case keys.down:
                    event.stop = true;
                    if ( screenList.visible ) {
                        screenList.focus();
                        page.$node.scrollTop = app.metrics.infoSroll.screen;
                    } else if ( seasonsButton.visible ) {
                        seasonsButton.focus();
                        page.$node.scrollTop = app.metrics.infoSroll.season - app.metrics.infoSroll.screen;
                    } else if ( seasonsList.visible ) {
                        seasonsList.focus();
                        page.$node.scrollTop = app.metrics.infoSroll.season - app.metrics.infoSroll.screen;
                    }
                    break;
                case keys.right:
                case keys.left:
                    // cursor move only on arrow keys
                    this.move(event.code);
                    event.stop = true;
                    break;
                case keys.enter:
                    // there are some listeners
                    if ( this.events['click:item'] && this.$focusItem ) {
                        // notify listeners
                        this.emit('click:item', {$item: this.$focusItem, event: event});
                    }
                    event.stop = true;
                    break;
            }
        }
    }
});

buttonMore = new Layout({
    focusable: true,
    data: [
        tag(
            'div',
            {className: 'buttonMore'},

            tag('div', {className: 'buttonLeft'}),
            tag('div', {className: 'buttonRight'}, gettext('More'))
        )

    ],
    className: 'buttonMoreContainer',
    events: {
        click: function () {
            app.route(app.pages.more, infoData);
        },
        keydown: function ( event ) {
            switch ( event.code ) {
                case keys.up:
                    event.stop = true;
                    break;
                case keys.down:
                    event.stop = true;
                    buttonList.focus();
                    break;
                case keys.right:
                case keys.left:
                    // cursor move only on arrow keys
                    event.stop = true;
                    break;
                case keys.back:
                    event.stop = true;
                    app.route(prevPage);
                    break;
                case keys.enter:
                    // there are some listeners
                    if ( this.events['click'] ) {
                        // notify listeners
                        this.emit('click');
                    }
                    event.stop = true;
                    break;
            }
        }
    }
});

page.$node.appendChild(infoBlock.$body);
infoBlock.$panel.appendChild(buttonMore.$node);
infoBlock.$panel.appendChild(buttonList.$node);

screenList = new CacheList({
    title: gettext('Screenshots'),
    hasEmptyItems: true,
    cycle: true,
    size: app.metrics.screenList.size,
    bufferSize: 5,
    render: require('../renders/item.list'),
    data: [],
    events: {
        keydown: function ( event ) {
            // if ( this.inSlide ) {
            //     switch ( event.code ) {
            //         case keys.up:
            //         case keys.down:
            //             event.stop = true;
            //             break;
            //         case keys.right:
            //         case keys.left:
            //             // cursor move only on arrow keys
            //             this.move(event.code);
            //             event.stop = true;
            //             break;
            //         case keys.enter:
            //         case keys.back:
            //             page.$node.scrollTop = scrollPosition;
            //             this.$slide.classList.add('hidden');
            //             this.inSlide = false;
            //             event.stop = true;
            //             break;
            //     }
            // } else {
            switch ( event.code ) {
                case keys.up:
                    event.stop = true;
                    page.$node.scrollTop = 0;
                    buttonList.focus();
                    break;
                case keys.down:
                    event.stop = true;
                    if ( seasonsButton.visible ) {
                        seasonsButton.focus();
                        page.$node.scrollTop = app.metrics.infoSroll.season;
                    } else if ( seasonsList.visible ) {
                        seasonsList.focus();
                        page.$node.scrollTop = app.metrics.infoSroll.season;
                    }
                    break;
                case keys.right:
                case keys.left:
                    // cursor move only on arrow keys
                    this.move(event.code);
                    event.stop = true;
                    break;
                case keys.enter:
                    // there are some listeners
                    if ( this.events['click:item'] && this.$focusItem ) {
                        // notify listeners
                        this.emit('click:item', {$item: this.$focusItem, event: event});
                    }
                    event.stop = true;
                    break;
            }
            // }
        },

        // 'click:item': function () {
        //     scrollPosition = page.$node.scrollTop;
        //     page.$node.scrollTop = 0;
        //     this.$slide.classList.remove('hidden');
        //     this.inSlide = true;
        // },

        // 'focus:item': function ( event ) {
        //     this.$slide.style.backgroundImage = 'url(' + event.$curr.value + ')';
        // },

        focus: function () {
            if ( this.$focusItem ) {
                this.emit('focus:item', {$curr: this.$focusItem});
            }
        }
    }

});
// page.$node.appendChild(screenList.$slide = tag('div', {className: 'screenshotsSlide hidden'}));
page.add(screenList);


seasonsList = new LayoutList({
    cycle: false,
    className: 'seasonsList',
    data: [],
    size: app.metrics.seasonsList.size,
    focusIndex: 0,
    events: {
        'click:item': function ( event ) {
            fillSeries(event.$item.data.value, function () {
                seriesList.prevFocus = seasonsList;
                seriesList.show();
                seriesList.focus();
            });
        },
        overflow: function ( event ) {
            if ( event.direction === keys.up ) {
                if ( seasonsButton.visible ) {
                    seasonsButton.focus();
                } else if ( screenList.visible ) {
                    screenList.focus();
                    page.$node.scrollTop = app.metrics.infoSroll.screen;
                } else {
                    buttonList.focus();
                    page.$node.scrollTop = 0;
                }
            }
        }
    }
});
page.add(seasonsList);


seasonsButton = new Layout({
    focusable: true,
    data: [
        tag(
            'div',
            {className: 'buttonMore'},

            tag('div', {className: 'buttonLeft'}),
            tag('div', {className: 'buttonRight'}, gettext('All seasons'))
        )
    ],
    className: 'buttonMoreContainer',
    events: {
        click: function () {
            seriesList.prevFocus = seasonsButton;
            fillSeason();
            seriesList.show();
            seriesList.focus();
        },
        keydown: function ( event ) {
            switch ( event.code ) {
                case keys.up:
                    event.stop = true;
                    if ( screenList.visible ) {
                        screenList.focus();
                        page.$node.scrollTop = app.metrics.infoSroll.screen;
                    } else {
                        buttonList.focus();
                        page.$node.scrollTop = 0;
                    }
                    break;
                case keys.down:
                    event.stop = true;
                    seasonsList.focus();
                    break;
                case keys.right:
                case keys.left:
                    // cursor move only on arrow keys
                    event.stop = true;
                    break;
                case keys.back:
                    event.stop = true;
                    app.route(prevPage);
                    break;
                case keys.enter:
                    // there are some listeners
                    if ( this.events['click'] ) {
                        // notify listeners
                        this.emit('click');
                    }
                    event.stop = true;
                    break;
            }
        }
    }
});
seasonsList.$node.insertBefore(seasonsButton.$node, seasonsList.$node.firstChild);
seasonsList.$node.insertBefore(tag('div', {className: 'title'}, gettext('Seasons')), seasonsList.$node.firstChild);


seriesList = new LayoutList({
    cycle: false,
    className: 'seriesList',
    data: [],
    size: app.metrics.seriesList.size,
    focusIndex: 0,
    render: require('../renders/series.list'),
    events: {
        'click:item': function ( event ) {
            var data = event.$item.data.value;

            switch ( data.type ) {
                case app.config.types.season:
                    this.history.push({data: data, position: event.$item.index});
                    fillSeries(data, function () {
                        seriesList.focus();
                    });
                    break;
                case app.config.types.series:
                    episode = data;
                    fillFileList(data, function () {
                        seriesList.blur();
                        selectFileModal.prevFocus = seriesList;
                        setTimeout(function () {
                            selectFileModal.show();
                        }, app.config.delay.modalShow);
                    });
                    break;
            }
        },

        show: function () {
            scrollPosition = page.$node.scrollTop;
            page.$node.scrollTop = 0;
            this.history = [];
        },

        hide: function () {
            if ( this.prevFocus ) {
                page.$node.scrollTop = scrollPosition;
                this.prevFocus.focus();
                this.prevFocus = null;
            }
        },

        keydown: function ( event ) {
            var data;

            switch ( event.code ) {
                case keys.back:
                    if ( this.history.length ) {
                        data = this.history.pop();
                        fillSeason(data);
                        this.focus();
                    } else {
                        this.hide();
                    }
                    event.stop = true;
                    break;
                case keys.up:
                case keys.down:
                case keys.right:
                case keys.left:
                    // cursor move only on arrow keys
                    this.move(event.code);
                    event.stop = true;
                    break;
                case keys.enter:
                    // there are some listeners
                    if ( this.events['click:item'] && this.$focusItem ) {
                        // notify listeners
                        this.emit('click:item', {$item: this.$focusItem, event: event});
                    }
                    event.stop = true;
                    break;
            }
        }
    }
});
page.add(seriesList);
seriesList.prevFocus = null;
seriesList.$node.insertBefore(seriesList.title = tag('div', {className: 'title'}, gettext('Seasons')), seriesList.$node.firstChild);
seriesList.hide();


selectFileModal = new ModalMessage({
    visible: false,
    title: gettext('Available video options'),
    events: {
        show: function () {
            this.children[0].focus();
        },
        hide: function () {
            if ( this.prevFocus ) {
                this.prevFocus.focus();
                this.prevFocus = null;
            }
        }
    },
    children: [
        fileList = new RadioList({
            focusIndex: 0,
            size: app.metrics.modal.size,
            cycle: true,
            data: [],
            events: {
                'click:item': function ( event ) {
                    prepareToPlay(event.$item.data.value);
                    selectFileModal.hide();
                },
                keydown: function ( event ) {
                    RadioList.prototype.defaultEvents.keydown.call(this, event);
                    switch ( event.code ) {
                        case keys.back:
                            selectFileModal.hide();
                            event.stop = true;
                            break;
                    }
                }
            }
        })
    ]
});
selectFileModal.prevFocus = null;
page.add(selectFileModal);


app.addListener('route', function ( data ) {
    if ( data.to === page ) {
        switch ( data.from ) {
            case app.pages.more:
                break;
            default:
                prevPage = data.from;
                break;
        }

    }
});


page.addListener('show',
    /**
     * Fill pages layouts.
     *
     * @this page
     *
     * @param {Object} event - event data contain types
     */
    function ( event ) {
        if ( !event || !event.data ) {
            return;
        }

        switch ( event.data.type ) {
            case 'start':
                prepareFiles();

                return;
            case 'continue':
                startLastWatched();

                return;
            case 'back':
                buttonMore.focus();

                return;
        }

        this.$node.scrollTop = 0;
        infoData = event.data.info;
        if ( DEVELOP ) {
            window.infoData = infoData;
        }

        if ( infoData.poster ) {
            infoBlock.$img.style.backgroundImage = infoData.poster;
        } else {
            infoBlock.$img.style.backgroundImage = '';
        }

        infoBlock.$title.innerText = infoData.name;
        infoBlock.$country.innerText = (infoData.year_end ? infoData.year + ' - ' + infoData.year_end : infoData.year) + ', ' +
            infoData.genre + ', ' + infoData.duration + ' ' + gettext('minutes');


        if ( infoData.rating_kinopoisk ) {
            infoBlock.$ratingKino.innerText = infoData.rating_kinopoisk;
            infoBlock.$ratingKino.style.display = '';
        } else {
            infoBlock.$ratingKino.style.display = 'none';
        }
        if ( infoData.rating_imdb ) {
            infoBlock.$ratingImdb.innerText = infoData.rating_imdb;
            infoBlock.$ratingImdb.style.display = '';
        } else {
            infoBlock.$ratingImdb.style.display = 'none';
        }
        if ( infoData.age ) {
            infoBlock.$censor.innerText = infoData.age;
            infoBlock.$censor.style.display = '';
        } else {
            infoBlock.$censor.style.display = 'none';
        }

        infoBlock.$director.innerText = infoData.director;
        infoBlock.$actors.innerText = infoData.actors;

        infoBlock.$description.innerText = infoData.description;
        if ( infoData.description.length ) {
            buttonMore.show();
        } else {
            buttonMore.hide();
        }
        if ( infoData.watched_status === 'not_ended' ) {
            if ( infoData.is_tv_series ) {
                buttonList.setData({data: buttonsSerialsWatch, focusIndex: 0});
            } else {
                buttonList.setData({data: buttonsDataWatch, focusIndex: 0});
            }
        } else {
            buttonList.setData({data: buttonsData, focusIndex: 0});
        }

        if ( infoData.favorite ) {
            buttonList.$node.classList.add('inFavorite');
        } else {
            buttonList.$node.classList.remove('inFavorite');
        }

        buttonList.focus();

        if ( infoData.screenshots.length > 0 ) {
            screenList.setData({data: utils.prepareScreenshots(infoData.screenshots), focusIndex: 0});
            screenList.show();
        } else {
            screenList.hide();
        }

        if ( infoData.is_tv_series ) {
            infoData.getSeasons(function ( error, seasons ) {
                if ( !error && seasons.length ) {
                    seasonData = seasons;
                    seasonsList.setData({focusIndex: 0, data: utils.prepareSeasons(seasons)});
                    seasonsList.show();
                    if ( seasons.length > seasonsList.size ) {
                        seasonsButton.show();
                    } else {
                        seasonsButton.hide();
                    }
                } else {
                    seasonsList.hide();
                }
            });
        } else {
            seasonsList.hide();
            seasonsButton.hide();
        }
    });


if ( DEVELOP ) {
    window.infoBlock = infoBlock;
    window.screenList = screenList;
    window.seasonsList = seasonsList;
    window.seriesList = seriesList;
    window.selectFileModal = selectFileModal;
    window.buttonList = buttonList;
}


page.addListener('keydown', function ( event ) {
    switch ( event.code ) {
        case keys.back:
            app.route(prevPage);
            break;
        case keys.f3:
            toggleFavorite();
            break;
    }
});


app.addListener('change:favorite', function ( data ) {
    var video = data.video;

    if ( video.favorite ) {
        buttonList.$node.classList.add('inFavorite');
    } else {
        buttonList.$node.classList.remove('inFavorite');
    }
});


module.exports = page;
